export default "__VITE_ASSET__DLlNVzcc__"